import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import { HomePage } from "@/components/auth/AppRoutePages";
export const Route = createFileRoute("/")({ head: ({match}) => pageHead(match.pathname), component: () => (<HomePage />) });
